import React, { forwardRef } from "react";
import {
  NumberFormatValues,
  NumericFormat,
  NumericFormatProps,
} from "react-number-format";

const MAX_VALUE = 999999.99;

interface CustomProps {
  onChange: (event: { target: { name: string; value: string } }) => void;
  name: string;
  isAllowed?: (values: NumberFormatValues) => boolean;
  maxValue?: number;
}

const CustomNumericFormat = forwardRef<NumericFormatProps, CustomProps>(
  function CustomNumericFormat(props, ref) {
    const { onChange, isAllowed, maxValue, ...other } = props;

    const handleDecimalSeparator = (e: React.FormEvent<HTMLInputElement>) => {
      // Replace all commas with dots and preserve cursor position (for iOS keyboard issue)
      const input = e.currentTarget;
      if (/,/.test(input.value)) {
        const { selectionStart, selectionEnd } = input;
        input.value = input.value.replace(/,/g, ".");
        if (selectionStart !== null && selectionEnd !== null) {
          input.setSelectionRange(selectionStart, selectionEnd);
        }
      }
    };

    return (
      <NumericFormat
        getInputRef={ref}
        onValueChange={(values) => {
          const cleanedValue = values.value.replace(/^0+(?=[^.])/g, "");

          onChange({
            target: {
              name: props.name,
              value: cleanedValue,
            },
          });
        }}
        thousandSeparator=" "
        valueIsNumericString
        allowNegative={false}
        onInput={handleDecimalSeparator}
        isAllowed={(values) => {
          const { value, floatValue } = values;
          const multipleZeros = /^0{2,}/.test(value);
          const underMax = (floatValue || 0) <= (maxValue || MAX_VALUE);

          if (isAllowed) {
            return !multipleZeros && underMax && isAllowed(values);
          }
          return !multipleZeros && underMax;
        }}
        {...other}
      />
    );
  }
);

export default CustomNumericFormat;
